module.exports = __webpack_public_path__ + "img/Gruselig.8450fa91.svg";